import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a969caa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "server-selection" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "New Data Source", -1))
const _hoisted_3 = { class: "server-dropdown" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "server" }, "Server:", -1))
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.selectedServer = $event)),
        id: "server"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.servers, (server) => {
          return (_openBlock(), _createElementBlock("option", {
            key: server.id,
            value: server.name
          }, _toDisplayString(server.name), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vModelSelect, $setup.selectedServer]
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.goNext && $setup.goNext(...args)))
    }, "Next")
  ]))
}